// extracted by mini-css-extract-plugin
export default {"list":"BorderCountriesList_list__yeUkz","title":"BorderCountriesList_title__RaqhY"};